module.exports = __webpack_public_path__ + "odstraneni-tetovaze_7_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_7_before_tn.jpg
// module id = 1432
// module chunks = 0